import React from 'react'
import "../CompStyles/Footer.css"

function Footer() {
  return (
    <div className='footer'>Made with ❤ By Apoorv</div>
  )
}

export default Footer